import React, { useEffect, useState, useContext } from "react";
import Select from "../ui-components/Select";
import ServiceConfiguratorAlertTCSQuestions from "./ServiceConfiguratorAlertTCSQuestions";
import Input from "../ui-components/Input";
import { FormattedMessage, useIntl } from "react-intl";
import _ from "lodash";
import apiRequest from "services/apiRequest";
import CountryContext from "../CountryContext";
import { validateEmail } from "utils/validate-email";
import Tooltip from "@ui-components/Tooltip";


const TCS_OPTIONS = [
  { value: "kerakoll", name: "Kerakoll" },
  { value: "partner", name: "Partner" },
];

const CATEGORIE_PRODOTTO = [
  "",
  "Preparazione Fondi di posa",
  "Impermeabilizzazione",
  "Ripristino e rinforzo strutturale - antisismico",
  "Sistemi tintometrici",
  "Posa ceramica e pietre naturali",
  "Posa parquet, resilienti e resine industriali",
  "Costruzione e finitura",
  "Decorazione: pitture, rivestimenti e smalti",
  "Isolamento Termico",
  "Sistemi naturali",
  "Color Collection",
].map((value) => ({ value, name: value }));

const MOTIVO_CONTATTO = [
  "",
  "Documentazione e certificazioni",
  "Prodotto e posa in opera",
  "Supporto alla progettazione e software",
  "Sopralluogo",
  "Altro",
].map((value) => ({ value, name: value }));

const MOTIVO_CONTATTO_SISTEMI_TINTOMETRICI = [
  "",
  "Formazione o informazioni tecniche",
  "Formula",
  "Meccanica",
  "Software",
  "Altro",
].map((value) => ({ value, name: value }));

const getOptionsByCategoria = (categoria) => {
  if (categoria === "Sistemi tintometrici")
    return MOTIVO_CONTATTO_SISTEMI_TINTOMETRICI;
  if (categoria === "Color Collection") {
    return [
      ...MOTIVO_CONTATTO.slice(0, -1),
      {
        value: "Formazione o informazioni tecniche",
        name: "Formazione o informazioni tecniche",
      },
      MOTIVO_CONTATTO[MOTIVO_CONTATTO.length - 1],
    ];
  }
  return MOTIVO_CONTATTO;
};

const ServiceConfiguratorAlertTCS = ({ metadata_, setMetadata }) => {
  const intl = useIntl();
  const { push } = useContext(CountryContext);
  const { country } = useContext(CountryContext);

  const [selectedTCSType, setSelectedTCSType] = useState(
    TCS_OPTIONS.find((el) => el.value === metadata_.tcsType) ||
      TCS_OPTIONS[0]
  );
  const [webCategoriaProdotto, setWebCategoriaProdotto] = useState(
    CATEGORIE_PRODOTTO.find(
      (el) => el.value === metadata_.webCategoriaProdotto
    ) || CATEGORIE_PRODOTTO[0]
  );
  const [webMotivoContatto, setWebMotivoContatto] = useState(
    [...MOTIVO_CONTATTO, ...MOTIVO_CONTATTO_SISTEMI_TINTOMETRICI].find(
      (el) => el.value === metadata_.webMotivoContatto
    ) || MOTIVO_CONTATTO[0]
  );
  const [alertText, setAlertText] = useState(metadata_.alertText);
  const [emailBody, setEmailBody] = useState(metadata_.emailBody);
  const [recipientEmail, setRecipientEmail] = useState(metadata_.recipientEmail);

  const mailErrors = [
    {
      icon: "XCircleIcon",
      message: intl.formatMessage({
        id: "user_not_found",
        defaultMessage: "Utente non registrato",
      }),
      color: "text-red-500",
    },
    {
      icon: "ExclamationTriangleIcon",
      message: intl.formatMessage({
        id: "user_mail_error",
        defaultMessage: "Email non valida",
      }),
      color: "text-yellow-500",
    },
    {
      icon: "CheckCircleIcon",
      message: intl.formatMessage({
        id: "user_found",
        defaultMessage: "Utente trovato",
      }),
      color: "text-green-500",
    },
  ];
  const [mailError, setMailError] = useState(mailErrors[0]);
  /**
   * Set TCS user with email check
   */
  async function mailCheck() {
    try {
      const res = await apiRequest.get(
        `/users/user?email=${recipientEmail}&country=${country.code}`
      );
      const isInvalid = res === "not_registered";
      setMailError(isInvalid ? mailErrors[0] : mailErrors[2]);

    } catch {
      push({
        title: intl.formatMessage({ id: "server_error" }),
        type: "error",
      });
    }
  }
  useEffect(async() => {
    if(!validateEmail(recipientEmail)) {
      setMailError(mailErrors[1]);
    } else if (recipientEmail && validateEmail(recipientEmail)) {
      await mailCheck();
    }
  }, [recipientEmail])

  useEffect(async() => {
    let _metadata_ = { ...metadata_ };
    _metadata_.tcsType = selectedTCSType.value;
    _metadata_.webCategoriaProdotto = webCategoriaProdotto.value;
    _metadata_.webMotivoContatto = webMotivoContatto.value;
    _metadata_.alertText = alertText;
    _metadata_.emailBody = emailBody;
    _metadata_.recipientEmail = recipientEmail;
    setMetadata(_metadata_);
  }, [
    selectedTCSType,
    webCategoriaProdotto,
    webMotivoContatto,
    alertText,
    emailBody,
    recipientEmail,
  ]);

  useEffect(() => {
    // reset the unused parameters to it's default value
    if (selectedTCSType.value === "kerakoll") {
      setEmailBody("");
      setRecipientEmail("");
    }

    if (selectedTCSType.value === "partner") {
      setWebCategoriaProdotto(CATEGORIE_PRODOTTO[0]);
      setWebMotivoContatto(MOTIVO_CONTATTO[0]);
    }
  }, [selectedTCSType]);

  return (
    <div>
      <Select
        label={intl.formatMessage({
          id: "tcs_type",
          defaultMessage: "Tipologia TCS",
        })}
        options={TCS_OPTIONS}
        value={selectedTCSType.value}
        onChange={(e) =>
          setSelectedTCSType(
            TCS_OPTIONS.find((opt) => opt.value === e.target.value)
          )
        }
      />
      {selectedTCSType.value === "kerakoll" && (
        <>
          <p className="mb-2">
            <FormattedMessage
              id="request_type"
              defaultMessage="Tipologia di richiesta"
            />
          </p>
          <Input value="Assistenza" disabled hideBottomMargin />

          <p className="mb-2">
            <FormattedMessage
              id="product_category"
              defaultMessage="Categoria di prodotto"
            />
          </p>
          <Select
            options={CATEGORIE_PRODOTTO}
            value={webCategoriaProdotto.value}
            onChange={(e) =>
              setWebCategoriaProdotto(
                CATEGORIE_PRODOTTO.find((opt) => opt.value === e.target.value)
              )
            }
          />

          {webCategoriaProdotto.value && (
            <>
              <p className="mb-2">
                <FormattedMessage
                  id="contact_reason"
                  defaultMessage="Motivo di contatto"
                />
              </p>
              <Select
                options={getOptionsByCategoria(webCategoriaProdotto.value)}
                value={webMotivoContatto.value}
                onChange={(e) =>
                  setWebMotivoContatto(
                    [
                      ...MOTIVO_CONTATTO,
                      ...MOTIVO_CONTATTO_SISTEMI_TINTOMETRICI,
                    ].find((opt) => opt.value === e.target.value)
                  )
                }
              />
            </>
          )}
        </>
      )}

      <p className="mb-2">
        <FormattedMessage id="alert_text" defaultMessage="Testo alert" />
      </p>
      <textarea
        className="px-2 py-2 pr-10 border shadow-sm focus:ring-am-500 focus:border-am-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:opacity-50"
        rows={4}
        value={alertText}
        onChange={(e) => setAlertText(e.target.value)}
      />

      {selectedTCSType.value === "partner" && (
        <>
          <p className="my-2">
            <FormattedMessage id="email_body" defaultMessage="Corpo email" />
          </p>
          <textarea
            className="mb-2 px-2 py-2 pr-10 border shadow-sm focus:ring-am-500 focus:border-am-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:opacity-50"
            rows={4}
            value={emailBody}
            onChange={(e) => setEmailBody(e.target.value)}
          />

          <div className="flex items-center justify-between">
            <Input
              value={recipientEmail}
              onChange={async (e) => setRecipientEmail(e.target.value)}
              label={intl.formatMessage({
                id: "recipient_email",
                defaultMessage: "Destinatario email",
              })}
              type="email"
              iconClasses={mailError.color}
            />
            <div className="flex items-center mt-3 ml-3">
              <Tooltip
                text={mailError.message}
                placement="top"
                iconName={mailError.icon}
                class={mailError.color}
              />
            </div>
          </div>
        </>
      )}
      <ServiceConfiguratorAlertTCSQuestions
        metadata_={metadata_}
        setMetadata={setMetadata}
      />
    </div>
  );
};

export default ServiceConfiguratorAlertTCS;
